import forms from './forms'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    fetchTools ({dispatch}) {
      dispatch('forms/fetchForms')
    }
  },
  modules: {
    forms
  },
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/tools/index.js